import type { ColumnDef } from '@tanstack/react-table';
import type { WithdrawRequestEntity } from 'services/openapi';
import React from 'react';
import {
  PointTransactionTypesColor,
  RequestWithdrawStatus,
} from 'configs/constants';
import { endOfDay, startOfDay } from 'date-fns';
import { DEFAULT_PAGE_INDEX, DEFAULT_PAGE_SIZE } from 'configs';
import { NumberUtils } from 'modules';
import { format } from 'date-fns';
import { RequestWithdrawStatusColor } from 'configs/constants';
import { formatDateTime } from 'utils/helpers/helpers';

export type FilterType = {
  transactionStatus: 'Tất cả' | 'Thành công' | 'Từ chối' | 'Đang xử lý';
  fromTime: string | number;
  toTime: string | number;
  refreshData: number;
  pageSize: number;
  pageIndex: number;
};

export const getInitFilterValues = (urlParams: any): FilterType => {
  return {
    transactionStatus:
      urlParams?.get('transactionStatus') ?? RequestWithdrawStatus['Tất cả'],
    fromTime:
      urlParams?.get('fromTime') ?? startOfDay(new Date()).toUTCString(),
    toTime: urlParams?.get('toTime') ?? endOfDay(new Date()).toUTCString(),
    refreshData: 0,
    pageSize: Number(urlParams?.get('pageSize') ?? DEFAULT_PAGE_SIZE),
    pageIndex: Number(urlParams?.get('pageIndex') ?? DEFAULT_PAGE_INDEX),
  };
};

export const columnsDefined: ColumnDef<WithdrawRequestEntity>[] = [
  {
    accessorKey: 'name',
    header: 'Ngân hàng',
    cell: (info) => {
      // return <div className='text-center'>{info.row.original?.bankAccount?.bank?.shortName} - {info.row.original?.bankAccount?.bank?.name}</div>
      return (
        <div className='text-center'>
          {info.row.original?.bankAccount?.bank?.shortName}
        </div>
      );
    },
  },
  {
    accessorKey: 'accountName',
    header: 'Tên tài khoản',
    cell: (info) => {
      return (
        <div className='text-center'>
          {info.row.original?.bankAccount?.accountName}
        </div>
      );
    },
  },
  {
    accessorKey: 'accountNumber',
    header: 'Số tài khoản',
    cell: (info) => {
      return (
        <div className='text-center'>
          {info.row.original?.bankAccount?.accountNumber}
        </div>
      );
    },
  },
  {
    accessorKey: 'amount',
    header: 'Số tiền', //ell
    cell: (info) => {
      return (
        <div className='textDanger'>
          {info.getValue()
            ? NumberUtils.toFormatNumber(Number(info.getValue()))
            : '0'}
        </div>
      );
    },
  },
  {
    accessorKey: 'status',
    header: 'Trạng thái',
    cell: (info) => (
      <div
        className={
          RequestWithdrawStatusColor[
            info.getValue() as keyof typeof RequestWithdrawStatusColor
          ]
        }
      >
        {String(info.getValue())}
      </div>
    ),
  },
  // {
  //   accessorKey: 'transactions',
  //   header: 'GD rút điểm',
  //   cell: (info) => {
  //     const txs: any  = info.getValue();
  //     console.log(txs)
  //     if(!txs || txs?.length == 0) return <></>
  //     const txReuest = txs.find((tx: any) => tx.transactionType === PointTransactionTypesColor['Rút điểm']);
  //     return <div className="textInfo">{txReuest.id}</div>
  //   }
  // },
  // {
  //   accessorKey: 'transactions',
  //   header: 'GD hoàn điểm',
  //   cell: (info) => {
  //     const txs: any  = info.getValue();
  //     if(!txs || txs?.length == 0) return <></>
  //     const txReuest = txs.find((tx: any) => tx.transactionType === PointTransactionTypesColor['Hoàn điểm']);
  //     return <div className="textDanger">{txReuest.id}</div>
  //   }
  // },
  {
    accessorKey: 'createdAt',
    header: 'Thời gian gửi',
    cell: (info) =>
      format(new Date(String(info.getValue())), 'HH:mm:ss dd/MM/yyyy'),
  },
  {
    accessorKey: 'confirmAt',
    header: 'Thời gian duyệt',
    cell: (info) =>
      info.getValue()
        ? format(new Date(String(info.getValue())), 'HH:mm:ss dd/MM/yyyy')
        : '',
  },
  {
    accessorKey: 'rejectReason',
    header: 'Nguyên nhân từ chối',
  },
  {
    accessorKey: 'transactionImageUrl',
    header: 'Hình ảnh',
    cell: (info) => {
      if (!info.row.original.transactionImageUrl) return <></>;
      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => {
            window.open(info.row.original.transactionImageUrl, '_blank');
          }}
        >
          <img
            style={{ width: 'auto', height: 25, objectFit: 'contain' }}
            src={info.row.original.transactionImageUrl}
            alt='Hình ảnh'
          />
        </div>
      );
    },
  },
];

export const convertVariables = (variables: FilterType) => {
  const { fromTime, toTime, ...rest } = variables;

  const newTimeFrom =
    typeof fromTime === 'string' ? new Date(fromTime).getTime() : fromTime;
  const newTimeTo =
    typeof toTime === 'string' ? new Date(toTime).getTime() : toTime;

  return {
    ...rest,
    fromTime: fromTime ? formatDateTime(Number(newTimeFrom)) : '',
    toTime: toTime ? formatDateTime(Number(newTimeTo), true) : '',
  };
};

export const convertSelectStatusOptions = () => {
  return Object.keys(RequestWithdrawStatus).map((key: string) => {
    return {
      label: RequestWithdrawStatus[key as keyof typeof RequestWithdrawStatus],
      value: key,
    };
  });
};
